import { Vendors } from 'common/consts/vendors';
import { AssetTypes } from 'common/assets/assets.const';

export const SUPPORTED = {
    VENDORS: [Vendors.AWS, Vendors.AZURE],
    INSIGHTS_ASSET_TYPES: [AssetTypes.AWS_INSTANCE],
    ASSET_TYPES: [] as string[],
};
